import { QuickLinkAccess, QuickLinkFormValues } from 'types';

export const defaultValues: QuickLinkFormValues = {
  title: '',
  icon: '',
  url: '',
  access: QuickLinkAccess.private,
};
